// extracted by mini-css-extract-plugin
export var Btn = "wbbutton-module--Btn--1fPPP";
export var icon = "wbbutton-module--icon--vQJ8v";
export var BtnPrimary = "wbbutton-module--BtnPrimary--za_hH";
export var pageGrid = "wbbutton-module--page-grid--Kl5Uk";